import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateExerciseNote } from "../../../redux/slices/customer/trainingSlice";

const NotesModal = ({ isOpen, onClose, currentNote, week_number, day_number, selectedExerciseParent }) => {
  const dispatch = useDispatch();
  const [note, setNote] = useState('');

  useEffect(() => {
      setNote(currentNote);
  }, [currentNote]);

  const handleSearch = (event) => {
    const term = event.target.value;
    setNote(term);
  };

  const handleSave = (e) => {
    e.preventDefault();
    var p = { exercise_id:selectedExerciseParent, notes:note, 'week_number':week_number, 'day_number':day_number};  
    dispatch(updateExerciseNote(p));
    onClose();
  };

  return isOpen ? (
    <div
      className="modal fade show replace-exercise-modal"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Update Note</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSave}>
              <div className="w-100 mt-4">
                
                <input
                  type="text"
                  id="search"
                  placeholder="Type note here"
                  value={note}
                  onChange={handleSearch}
                  className="form-control"
                />
              </div>
              <div className="form-group mb-0 mt-4">
                <button
                  type="submit"
                  className="btn-curve w-100"
                  disabled={!note}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default NotesModal;